import {
  UPDATE_AUTH,
  UPDATE_USER,
  SET_PROFESSIONS,
  SET_MAJ_NIXINUT,
  SET_PAYS,
  SET_VILLES,
  SET_PROVINCES,
  SET_TYPES_LICENCES,
  SET_STATUTS_SPORTIFS,
  SET_POSTES,
  SET_ROUTES,
  SET_DIPLOMES,
  SET_NOTIFICATIONS,
  CLEAR_ALL_DATA
} from './mutations-type'

var _ = require('underscore');

// initial state
const state = {
  appVersion: "2.5.0",
  professions: null,
  notifications: null,
  majNixinut: null,
  pays: null,
  provinces: null,
  villes: null,
  typesLicences: null,
  statutsSportifs: null,
  postes: null,
  diplomes: null,

}


// mutations
const mutations = {
  [SET_PROFESSIONS](state, message) {
    state.professions = message;
  },
  [SET_MAJ_NIXINUT](state, message) {
    state.majNixinut = message;
  },

  [SET_PAYS](state, message) {
    state.pays = message;
  },
  [SET_PROVINCES](state, message) {
    state.provinces = message;
  },
  [SET_POSTES](state, message) {
    state.postes = message;
  },
  [SET_ROUTES](state, message) {
    state.appRoutes = message;
  },
  [SET_VILLES](state, message) {
    state.villes = message;
  },
  [SET_TYPES_LICENCES](state, message) {
    state.typesLicences = message;
  },
  [SET_STATUTS_SPORTIFS](state, message) {
    state.statutsSportifs = message;
  },
  [SET_DIPLOMES](state, message) {
    state.diplomes = message;
  },
}

const actions = {
  setProfessions({ commit }, msg) {
    commit(SET_PROFESSIONS, msg)
  },
  setMajNixinut({ commit }, msg) {
    commit(SET_MAJ_NIXINUT, msg)
  },
  setPays({ commit }, msg) {
    commit(SET_PAYS, msg)
  },
  setProvinces({ commit }, msg) {
    commit(SET_PROVINCES, msg)
  },
  setPostes({ commit }, msg) {
    commit(SET_POSTES, msg)
  },
  setVilles({ commit }, msg) {
    commit(SET_VILLES, msg)
  },
  setTypesLicences({ commit }, msg) {
    commit(SET_TYPES_LICENCES, msg)
  },
  setStatutsSportifs({ commit }, msg) {
    commit(SET_STATUTS_SPORTIFS, msg)
  },
  setDiplomes({ commit }, msg) {
    commit(SET_DIPLOMES, msg)
  },
}

const getters = {
  getProcessEnv: state => {
    return process.env;
  },
  getProfessions: state => {
    return state.professions;
  },
  getMajNixinut: state => {
    return state.majNixinut;
  },
  getPays: state => {
    return state.pays;
  },
  getProvinces: state => {
    return state.provinces;
  },
  getPostes: state => {
    return state.postes;
  },
  getVilles: state => {
    return state.villes;
  },
  getTypesLicences: state => {
    return state.typesLicences;
  },
  getStatutsSportifs: state => {
    return state.statutsSportifs;
  },
  getDiplomes: state => {
    return state.diplomes;
  },

  getProdVersion: state => {
    return state.appVersion;
  },

}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/store-app.js